<script lang="ts">
  import { store } from '$lib/store.svelte';
  import type { ViewName } from '$lib/types';

  const items: { id: ViewName; label: string }[] = [
    { id: 'ideas', label: 'Embudo' },
    { id: 'agentes', label: 'Agentes' },
    { id: 'archivo', label: 'Archivo' },
    { id: 'sync', label: 'Sync' }
  ];
</script>

<nav class="mobile-bar">
  {#each items as item}
    <button type="button" class="mobile-bar-btn" class:active={store.view === item.id} onclick={() => store.setView(item.id)}>
      <span>{item.label}{item.id === 'agentes' && store.pendientes.length ? ` (${store.pendientes.length})` : ''}</span>
    </button>
  {/each}
</nav>
